"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.couponUtil = void 0;
/**
 * A utility function that sets a coupon label and icon after a specified timeout.
 *
 * @param {Function} setCouponLabel - A state setter function to update the coupon label.
 * @param {Function} setCouponIcon - A state setter function to update the coupon icon.
 * @param {Object} couponDetails - An object containing coupon details.
 * @param {string} [couponDetails.couponLabel] - The label to be set when the coupon is applied.
 *
 * @returns {number|undefined} The timer ID for the timeout, or undefined if couponDetails is falsy.
 */

const couponUtil = (setCouponLabel, setCouponIcon, setCouponContainerTitle, couponDetails) => {
  if (!couponDetails) {
    return;
  }
  const update = setTimeout(() => {
    setCouponLabel(couponDetails?.couponLabel);
    setCouponIcon('copy');
    setCouponContainerTitle('Copy to Clipboard');
  }, 5000);
  return update;
};
exports.couponUtil = couponUtil;